import React, { useContext, useState, useEffect } from 'react';
import './PopupScreen.css';
import cn from "classnames";
import styles from './PopupScreen.module.sass';
import Modal from '@mui/material/Modal';
import Card from '../../../../components/Card';
import { GlobalState } from '../../../../App';
import TextInput from '../../../../components/TextInput';


const PopupScreen = ({ otp }) => {

  const [enteredOtp, setEnteredOtp] = useState()

  const { setOtpValidation,
    showModalView, setShowModalView
  } = useContext(GlobalState)


  const handleClose = () => {
    setShowModalView(false);
    setEnteredOtp()
  }
  return (
    <Modal
      disableAutoFocus={true}
      open={showModalView}
      // onClose={handleClose}
      className='dialog-wrapper'
      sx={{
        outline: '0 !important',
        border: 'none !important'
      }}
    >
      <Card
        className={cn(styles.card)}
        title="OTP is Required"
        classTitle="title-green"
        classCardHead={styles.cardHead}
        head={
          <div style={{
            display: 'flex',
            gap: '12px'
          }}>

            <button
              onClick={() => {
                if (enteredOtp == otp) {
                  setOtpValidation('VALID')
                  handleClose()
                } else {
                  setOtpValidation('INVALID')
                  alert("Invalid OTP!")
                  handleClose()
                }

              }}
              className={cn("button", styles.button)} >
              <span>Confirm</span>
            </button>
            {/* <button
              // onClick={() => {
              //   setShowModalViewLocation(false)
              // }}
              className={cn(styles.closeButton)} >
              <Icon name="close" fill="red" size="16" />
            </button> */}
          </div>

        }
      >
        <div className={cn(styles.fieldContainer, styles.titleEnFieldContainer)}>
          <TextInput
            className={styles.field}
            classInput={styles.fieldInput}
            label="Enter the OTP received by the designated email."
            name="popupOtpTitle"
            onChange={(e) => {
              e.target.value = e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1');
              setEnteredOtp(e.target.value)
            }}
            value={enteredOtp}
            required
          />
          <p className={styles.errField} id="locationTitlePopupErrId"></p>
        </div>

      </Card>

    </Modal>

  )
}

export default PopupScreen